import { Routes } from '@angular/router';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { operatorGuardFn } from './core/guards/operator.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'not-found',
    pathMatch: 'full',
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: 'preview',
    loadComponent: () =>
      import(
        './features/landing-page/src/lib/containers/landing-page-container/' +
          'landing-page-container.component'
      ).then((m) => m.LandingPageContainerComponent),
  },
  {
    path: ':schoolId',
    canActivate: [operatorGuardFn],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './features/landing-page/src/lib/containers/landing-page-container/' +
              'landing-page-container.component'
          ).then((m) => m.LandingPageContainerComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
